module.exports = __webpack_public_path__ + "img/tradeAccess-logo-desc.d7c84b52.png";